module.exports = __webpack_public_path__ + "img/gyljr.d21cdfd6.png";